<mat-card>
    <mat-toolbar color="primary">Consultas Gerenciais</mat-toolbar>
    <mat-card-content>
        @if (consultasGerenciais.length === 0) {
        <div class="indisponivel">
            <span>Ainda não existem consultas personalizadas disponíveis!</span>
        </div>
        }
        @if (!consultaSelecionada) {
        <div class="itens-flex">
            @for (consulta of consultasGerenciais; track $index) {
            <button mat-fab extended
                color="primary"
                class="button-acao"
                (click)="executarAcaoConsulta(consulta)">
                <mat-icon>description</mat-icon>
                <span class="texto-botao">{{consulta.tituloConsulta}}</span>
            </button>
            }
        </div>
        }
        @if (consultaSelecionada) {
        <div class="scrollBar">
            <div class="titulo-consulta">
                @if (consultaSelecionada) {
                <button mat-icon-button color="primary" (click)="voltarParaLista()">
                    <mat-icon>arrow_back</mat-icon>
                </button>
                }
                <h3>{{consultaSelecionada.tituloConsulta}}</h3>
            </div>
            <span>{{consultaSelecionada.descricao}}</span>
            @if (!isPesquisando && respostaConsulta && respostaConsulta.length > 0) {
            <table class="tabela tabela-responsive">
                <thead>
                    <tr>
                        @for (consulta of respostaConsulta[0]; track $index) {
                        <th>
                            {{consulta.descricao}}
                        </th>
                        }
                    </tr>
                </thead>
                <tbody>
                    @for (consulta of respostaConsulta; track $index) {
                    <tr>
                        @for (campo of consulta; track $index) {
                        <td>
                            {{ campo.valor }}
                        </td>
                        }
                    </tr>
                    }
                </tbody>
            </table>
            }
        </div>
        }
        <div class="alinhar-itens">
			@if (isPesquisando) {
			<mat-spinner class="spinner-align" mode="indeterminate">
			</mat-spinner>
			}
		</div>
    </mat-card-content>
</mat-card>
